import React from 'react'
import TrashSvg from 'images/modules/Manage/i-trash.svg?raw'

export { default as TrashUrl } from 'images/modules/Manage/i-trash.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: TrashSvg}} />
)
